import { useEffect } from "react";
import Highcharts from "highcharts";
import { OptionsSpiderwebSeries } from "store/slice/charts";

const useCustomiseLabelsSpiderwebs = (
    showRoles: boolean,
    showNames: boolean,
    setChartOptions:
        | React.Dispatch<React.SetStateAction<Highcharts.Options>>
        | React.Dispatch<React.SetStateAction<OptionsSpiderwebSeries>>,
    legendSelected: number[]
): void => {
    useEffect(() => {
        setChartOptions((options: OptionsSpiderwebSeries | Highcharts.Options) => {
            const { series, ...restOptions } = options;

            const newSeries =
                series && //@ts-ignore
                series.map(({ data, ...restSerieOptions }) => {
                    const entityName = restSerieOptions?.custom?.entity_name ?? restSerieOptions?.name ?? "";
                    const role = restSerieOptions?.custom?.current_job_title ?? "";
                    const isPerson = restSerieOptions?.custom?.entity_type === "person";
                    const newName = `${showNames ? entityName : ""} ${showNames && showRoles ? "</br>" : ""} ${
                        showRoles ? role : ""
                    }`;
                    return {
                        data,
                        ...restSerieOptions,
                        ...(isPerson ? { name: newName } : {}),
                    };
                });

            return { ...restOptions, series: newSeries };
        });
    }, [showRoles, showNames, setChartOptions, legendSelected]);
};

export default useCustomiseLabelsSpiderwebs;
